import { create } from "zustand";

type WorkflowEnvState = {
	env: Record<string, string> | null;
	setEnv: (env: Record<string, string> | null) => void;
	clear: () => void;
};

export const useWorkflowEnvStore = create<WorkflowEnvState>((set) => ({
	env: null,
	setEnv: (env) => set({ env }),
	clear: () => set({ env: null }),
}));
